export default "__VITE_ASSET__9eac6378__"